/* Filter redesign (2026-07-10): two small enhancements for the collection
 * filter UI. Pure progressive enhancement - removing this file leaves a
 * fully working filter (neutral slider track, plain "Apply" label).
 *
 * 1) Price slider fill: keeps the brand-colored segment between the two
 *    range handles in sync by setting --fill-left / --fill-right CSS vars
 *    on the <range-slider> element (consumed by range-slider.css).
 *
 * 2) Apply button result count: appends the already-localized results text
 *    ("39 products" / "39 Produkte" / ...) to the mobile drawer's Apply
 *    button, e.g. "Apply · 39 products". Both parts come from the theme's
 *    own translations, so no new locale keys are needed.
 */
(function () {
  'use strict';
  if (window.__hhFiltersExtras) return;
  window.__hhFiltersExtras = true;

  function updateFill() {
    var sliders = document.querySelectorAll('range-slider');
    sliders.forEach(function (rs) {
      var min = rs.querySelector('input.min');
      var max = rs.querySelector('input.max');
      if (!min || !max) return;
      var top = parseFloat(max.max) || 0;
      if (top <= 0) return;
      var lo = Math.max(0, Math.min(parseFloat(min.value) || 0, top));
      var hi = Math.max(lo, Math.min(parseFloat(max.value) || top, top));
      rs.style.setProperty('--fill-left', (lo / top * 100).toFixed(2) + '%');
      rs.style.setProperty('--fill-right', (hi / top * 100).toFixed(2) + '%');
    });
  }

  function updateApply() {
    var apply = document.querySelector('.filters-sidebar_apply');
    var results = document.querySelector('.filter-header_results-text');
    if (!apply) return;
    if (!apply.dataset.baseLabel) apply.dataset.baseLabel = apply.textContent.trim();
    var txt = results ? results.textContent.trim() : '';
    apply.textContent = txt ? apply.dataset.baseLabel + ' · ' + txt : apply.dataset.baseLabel;
  }

  function refresh() {
    updateFill();
    updateApply();
  }

  /* live slider dragging */
  document.addEventListener('input', function (e) {
    if (e.target && e.target.closest && e.target.closest('range-slider')) updateFill();
  });

  /* after every filter fetch the theme re-renders .filters-head (results
     text) and the range values - observe and re-sync */
  function observe() {
    var head = document.querySelector('.filters-head');
    if (head) new MutationObserver(refresh).observe(head, { childList: true, subtree: true });
    var range = document.getElementById('price-range');
    if (range) new MutationObserver(updateFill).observe(range, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'data-load'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { refresh(); observe(); });
  } else {
    refresh();
    observe();
  }
})();
